import styled from 'styled-components';
const percentageSize = 1.3;

export const CercaAvançadaContainer = styled.div`
  display: ${({ cercaAvançadaOpen }) => (cercaAvançadaOpen ? 'inline-block' : 'none')};

  background-color: rgba(51, 51, 51, 0.85);
  /* height: ${(props) => props.mapHeight}; */
  height: 75%;
  position: fixed;
  left: 0;
  top: 40px;
  z-index: 9;
  width: 100%;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  /* opacity: 90%; */
  @media screen and (max-width: 768px) {
    top: 80px;
    height: calc(100% - 80px);
  }
`;

export const CercaAvançadaWrapper = styled.div`
  height: 100%;
`;

export const CercaAvançadaHeader = styled.div`
  border-bottom: 1.5px solid transparent;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  margin-left: 18%;

  @media screen and (max-height: 400px) {
    margin-left: 5%;
    margin-right: 5%;
  }

  @media screen and (max-width: 768px) {
    overflow-y: hidden;
    width: 100%;
    height: 110%;
    margin-left: 0px;
    margin-right: 0px;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
`;

export const CercaAvançadaTitleContainer = styled.div`
  height: 100%;
`;

export const CercaAvançadaTitleWrapper = styled.div`
  width: fit-content;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  box-sizing: content-box;
  white-space: nowrap;
  height: 40px;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const CercaAvançadaTitle = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 18 * percentageSize : 18)}px;
  width: fit-content;
  box-sizing: inherit;
  margin: 0;
  z-index: 1;
  padding-right: 15px;
  height: 100%;
  padding-left: 15px;
  font-weight: ${(props) => (props.selected ? '500' : '200')};
  line-height: 1.2;
  color: ${(props) => (props.selected ? '#febf00' : 'white')};
  cursor: pointer;
  border-bottom: ${(props) => (props.selected ? '4px solid #febf00;' : 'none')};

  @media screen and (max-width: 768px) {
    height: 92%;
  }
`;

export const CercaAvançadaCloseBtn = styled.button`
  background: transparent;
  color: white;
  opacity: 90%;
  border-radius: 50%;
  border: 0;
  padding-right: 1%;
  box-sizing: border-box;
  text-align: right;
  position: absolute;
  right: 0;
  top: 10px;
  @media screen and (max-width: 464px) {
    display: none;
  }
`;

export const CercaAvançadaCloseBtnIcon = styled.img`
  vertical-align: top;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: #b7b7b7;
  width: 98%;
  height: 2px;
  margin-left: auto;
  margin-right: auto;
  opacity: 80%;
`;

export const CercaAvançadaBodyWrapper = styled.div`
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const CercaAvançadaInstrucciones = styled.div`
  width: 50%;
  overflow-y: auto;
  margin-top: 25px;
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-top: 5px;
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    padding-right: 15px;
    max-height: calc(100% - 320px);
    overflow: hidden scroll;
  }
`;

export const CercaAvançadaBody = styled.div`
  margin: 0px 18%;
  height: calc(100% - 130px);
  display: flex;
  gap: 40px;
  @media screen and (max-height: 400px) {
    margin-left: 5%;
    margin-right: 5%;
  }
  @media screen and (max-width: 1000px) {
    margin: 0px 5%;
  }

  @media screen and (max-width: 768px) {
    overflow-y: hidden;
    display: block;
    width: 100%;
    height: 100%;
    top: 15px;
    position: absolute;
    margin-left: 10px;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
`;

export const TextInputVerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-left: 18%; */

  @media screen and (max-width: 768px) {
    margin-left: 0px;
    width: 100%;
  }
`;

export const TextInput = styled.input`
  all: unset;
  color: white;
  border-bottom: 1px solid;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
  font-size: 15px;
  ::placeholder {
    color: #aaaaaa;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
    transition-delay: 9999s;
  }
  @media screen and (max-width: 768px) {
    margin-left: 0px;
    padding: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 95%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  /* width: 50%; */
  margin-top: 25px;
  /* margin-left: 18%; */

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-left: 0px;
  }
`;

export const NormalButton = styled.button`
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  color: white;
  background: #666666;
  border: none;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  /* font-weight: bold; */
  width: 150px;
  height: 32px;
  margin-left: 10px;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  @media screen and (max-width: 768px) {
    width: 48%;
  }
`;

export const TransparentButton = styled.button`
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  background: transparent;
  color: #cccccc;
  border: 1px solid #cccccc;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  /* font-weight: bold; */
  width: 150px;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  @media screen and (max-width: 768px) {
    width: 48%;
  }
`;

export const CercaBody = styled.article`
  height: 100%;
  display: block;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
`;

export const CercaBodyWrapper = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  @media screen and (max-width: 768px) {
    position: unset;
  }
`;

export const TitolCercaBody = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 15 * percentageSize : 15)}px;
  margin: 0px 0px 5px 18%;
  font-weight: 400;
  color: white;
  height: 20px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
    margin-left: 10px;
  }

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 11 * percentageSize : 11)}px;
    font-weight: 500;
    margin-left: 10px;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 25px;
`;

export const TornarAlMapaButton = styled.button`
  margin-top: 15px;
  margin-bottom: 15px;
  height: 32px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  background: #c00000;
  color: white;
  padding: 3px 25px;
  border: none;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  font-weight: bold;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px 25px;
  }
`;

export const CercaFooterWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-left: 18%;
  justify-content: flex-start;

  @media screen and (max-width: 768px) {
    padding-left: 0px;
    justify-content: center;
  }
`;

export const CercaFooter = styled.footer`
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: -100px;
  padding-left: 1%;
  padding-right: 1%;
`;

export const InstruccionsTitle = styled.div`
  font-weight: bold;
  display: flex;
`;
export const InstruccionsDesc = styled.div`
  margin-bottom: 5px;
  padding-bottom: 5px;
`;

export const Operador = styled.div`
  width: 35px;
`;

export const InstruccionsHeader = styled.div``;

export const InstruccionsWrapper = styled.div`
  border-bottom: 1px solid #ffffff60;
  margin: 10px 0;
  display: flex;
`;

export const InstruccionsTextWrapper = styled.div``;
